import { gql } from '@urql/core';
import { CollegeCardFragment, Espin_College_Game } from 'generated/spin-graphql';
import Link from 'next/link';
import React, { useMemo } from 'react';
import { PlainTextLocationDisplay } from '../common/PlainTextLocationDisplay';
import { GameIcon } from '../icons/GameIcon';
import { PictureWithFallback } from '../sections/PictureWithFallback';

type Props = {
    className?: string;
    college: CollegeCardFragment;
};

gql`
    fragment CollegeCardContent on espin_college {
        program_name
        college_games {
            game {
                game_definition
            }
        }
        address {
            ...PlainTextLocationDisplay
        }
        logo {
            ...SpinContentImageDisplay
        }
    }
`;

export const CollegeCardContent: React.FC<Props> = ({ className, college }) => {
    return (
        <div className="college-card-content">
            <div className="college-icon">
                <PictureWithFallback
                    icon={college.logo}
                    width={130}
                    height={130}
                    alt={`${college.program_name}} profile picture`}
                />
            </div>
            <h2 className="program-name">{college.program_name}</h2>
            <p className="program-location">
                <PlainTextLocationDisplay address={college.address} />
            </p>
            <div className="bottom-container">
                {college.college_games.length > 0 && (
                    <>
                        <p className="games-played">Games Played</p>
                        <div className="games-container">
                            {college.college_games.map((game: Espin_College_Game) => (
                                <GameIcon
                                    key={`game-${game.game.game_definition}`}
                                    game={game.game.game_definition}
                                    gameName={game.game.name}
                                />
                            ))}
                        </div>
                    </>
                )}
                <Link href={`/colleges/${college.slug}`}>
                    <a className="button blue-button medium-button">Learn More</a>
                </Link>
            </div>
        </div>
    );
};
